export const TOP_MENU_HEIGHT = 45; // don't change this
export const LEFT_MENU_WIDTH = 160; // don't change this
export const SUPPORT_LINK = "https://github.com/sponsors/derneuere";
